export default "__VITE_ASSET__lqXd8bia__"